import React, { useContext, useEffect, useState } from "react";
import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import { useForm } from 'react-hook-form';
import LogicContext from "../../Context/LogicContext";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import PaymentVendorSelect from "./PaymentVendorSelect";
import { GetPaymentMadeAtom } from "../../store/paymentMadeAtom";
import { paymentMadeService } from "../../services/paymentMade";
import PaymentMadeMethod from "./PaymentmadeMethod";
import { formatCustomDate, formatCustomDateWithoutTime } from "../../helpers/formatCustomDate";
import { formatCustomNumber } from "../../helpers/formatCustomNumber";
import {  GetPaymentEdit, ResetPaymentEdit } from "../../store/paymentMadeAtom";
import PaymentMadeTaxSelect from "./PaymentMadeTaxSelect";
import { NumericFormat } from 'react-number-format';


export default function PaymentMadeAddNewPage() {
  const paymentAtomData = GetPaymentMadeAtom();
  const resetEdit = ResetPaymentEdit();
  const paymentEdit = GetPaymentEdit();
  const myPromiseModal = createModal(GeneralModal);
  const [form, setForm] = useState({
    payment_date: new Date().toISOString().substring(0, 10),
    vendor_id: "",
    reference_number: "",
    payment_through_id: "",
    payment_notes: "",
    tds_id: "1",
    remark: "",
    xml_bill: "",
  });

  const { register, handleSubmit, setValue, getValues, formState: { errors } } = useForm();

  const navigate = useNavigate();

  const [vendorBillList, setVendorBillList] = useState([]);
  const { showToast, httpResponseManager } = useContext(LogicContext);
  const [showTaxSelect, setShowTaxSelect] = useState(false);
  const [totalPaymentAmount, setTotalPaymentAmount] = useState('');
  const [excessAmount, setExcessAmount] = useState(0);
  const [prevExcessAmount, setPrevExcessAmount] = useState(0);
  const [adjustmentAmount, setAdjustmentAmount] = useState(0);


  useEffect(() => {
    if (paymentEdit?.payment_info?.[0]?.payment_ref_no) {
      setValue('payment_ref_no', paymentEdit?.payment_info?.[0]?.payment_ref_no);
      const formattedDate = moment(paymentEdit?.payment_info?.[0]?.payment_date).format('YYYY-MM-DD');
      setValue('payment_date', formattedDate);
      setValue('vendor_id', paymentEdit?.payment_info?.[0]?.vendor_id);
      setValue('payment_through_id', paymentEdit?.payment_info?.[0]?.payment_through_id);
      const excessAmt = paymentEdit?.payment_info?.[0]?.excess_amount || 0;
      setPrevExcessAmount(excessAmt);
      setVendorBillList(paymentEdit?.bill_info || []);
    }

    return () => {
      resetEdit();
    };
  }, [paymentEdit, setValue]);


  const updatePayingAmount = (id, value, bill) => {
    const newAmount = Number(value) || 0;
    if (newAmount > Number(bill.remaining_amount)) {
      return showToast('Payment amount cannot be greater than remaining amount', 'error');
    }

    const updatedList = vendorBillList.map((bill) =>
      bill.bill_ref_no === id
        ? { ...bill, payment_amount: newAmount }
        : bill
    );

    setVendorBillList(updatedList);

    const totalPaid = updatedList.reduce(
      (sum, bill) => sum + Number(bill.payment_amount || 0),
      0
    );

    const totalPayment = Number(totalPaymentAmount) || 0;
    const diff = totalPayment - totalPaid;
    setExcessAmount(diff > 0 ? diff : 0);
  };

  // Function to distribute total payment amount across bills
  const handleTotalPaymentChange = (value) => {
    setTotalPaymentAmount(value);

    if (!value || value <= 0) {
      setExcessAmount(0);
      setVendorBillList((prev) =>
        prev.map((bill) => ({ ...bill, payment_amount: 0 }))
      );
      return;
    }

    let remainingAmount = Number(value);

    const updatedList = vendorBillList.map((bill) => {
      if (remainingAmount <= 0) {
        return { ...bill, payment_amount: 0 };
      }

      const remainingBillAmount = Number(bill.remaining_amount) || 0;
      const paymentForThisBill = Math.min(remainingAmount, remainingBillAmount);
      remainingAmount -= paymentForThisBill;

      return { ...bill, payment_amount: paymentForThisBill };
    });

    setVendorBillList(updatedList);

    if (remainingAmount > 0) {
      setExcessAmount(remainingAmount);
    } else {
      setExcessAmount(0);
    }
  };


  const handleSave = async () => {
    let option = '1';
    const formVal = getValues();

    if (excessAmount > 0) {
      const confirmExcess = await myPromiseModal({
        title: `You have excess amount of ${excessAmount} `,
        body: `The excess money will be transfered to your account`,
        showInput: false,
      });
      if (!confirmExcess) {
        setExcessAmount(0);
      }
    }

    if (paymentEdit?.payment_info?.[0]?.payment_ref_no) {
      option = '2';
    }

    const payThroughAcc = getValues('payment_through_id');
    if (!payThroughAcc) {
      return showToast('Please select a Pay Through Account', 'error');
    }

    const confirm = await myPromiseModal({
      title: ` ${paymentEdit?.payment_info?.[0]?.payment_ref_no ? "Update Payment Record" : "Save Payment Record"} `,
      body: `You are about confirm payment for item(s)`,
      showInput: false,
    });
    if (!confirm?.decision) return;

    const xmlItems = vendorBillList
      .map(item => `<a><bill_ref_no>${item.bill_ref_no}</bill_ref_no><amount>${item.payment_amount}</amount> </a>`)
      .join('');

    try {
      const res = await paymentMadeService.submitPaymentMade({
        ...formVal,
        excess_amount: excessAmount,
        adjustment_amount: adjustmentAmount || 0,
        xml_bill: `<root>${xmlItems}</root>`,
        option: option,
      });
      const response = httpResponseManager(res.data?.[0] || res.data?.result_status?.[0]);

      if (response.message_id === 1) {
        showToast(response.message_text || 'Payment Made successful!', 'success');
        sessionStorage.setItem('reloadPage', 'true');
        navigate(-1);
      } else {
        showToast(response.message_text || 'Failed to save', 'error');
      }
    } catch (err) {
      // showToast('Error submitting form', 'error');
    }
  };


  const handleCancel = () => {
    navigate(-1);
  };


  const onVendorSelect = async (vendor) => {
    console.log('vendor ', vendor);
    setValue('vendor_id', vendor.vendor_id);
    setVendorBillList([]);
    setTotalPaymentAmount('');
    setExcessAmount(0);
    setAdjustmentAmount(0);
    const res = await paymentMadeService.paymentMadeVendor(vendor.vendor_id);
    console.log('res.data ', res.data);
    const excessAMT = res.data?.access_amount?.[0]?.access_amount || 0;
    setPrevExcessAmount(excessAMT);
    if (res.data?.bill_info?.length) {
      setVendorBillList(res.data?.bill_info);
    } else {
      showToast('The Vendor  do not have Bill(s)');
    }
  };

  const onPaymentMethodSelect = async (sel) => {
    setValue('payment_through_id', sel.account_id);
  };

  const onTaxTypeSelect = async (sel) => {
    setValue('tsd_account_id', sel.account_id);
  };

  const handleAdjustmentAmountChange = (value) => {
    setAdjustmentAmount(value);
  };

  const baseDateData = paymentEdit?.payment_info?.[0]?.transfer_date;
  const defaultDate = baseDateData
    ? moment(baseDateData).format('YYYY-MM-DD')
    : moment().format('YYYY-MM-DD');

  const handleAdjustExcessAmount = () => {
    setAdjustmentAmount(prevExcessAmount);
    setPrevExcessAmount(0);
    showToast('Excess Amount now in adjustment input', 'info');
    return;
  };


  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 p-4 md:p-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-slate-800 mb-2"> New Payment Made </h1>
          <p className="text-slate-600">Create payment made </p>
        </div>

        {/* Main Form Card */}
        <div className="bg-white rounded-xl shadow-lg overflow-hidden mb-6">
          <div className="bg-gradient-to-r from-blue-600 to-blue-700 px-2 py-2">
            <h2 className="text-lg font-semibold text-white flex items-center gap-2">
              <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              Payment Information
            </h2>
          </div>

          <div className="p-6">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              <div>
                <label className="block text-sm font-semibold text-slate-700 mb-2">
                  Reference Number
                </label>
                <input
                  className="w-full border border-slate-300 rounded-lg px-4 py-2.5 text-sm bg-slate-50 text-slate-500"
                  placeholder="Enter reference No"
                  {...register('reference_number', { required: 'Reference No is required' })}
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-slate-700 mb-2">
                  Payment Date <span className="text-red-500">*</span>
                </label>
                <input
                  type="date"
                  className="w-full border border-slate-300 rounded-lg px-4 py-2.5 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                  defaultValue={defaultDate}
                  {...register('payment_date', { required: 'Payment date is required' })}
                />
                {errors.payment_date && (
                  <p className="text-red-500 text-xs mt-1">{errors.payment_date.message}</p>
                )}
              </div>

              <div className="md:col-span-2 lg:col-span-1 lg:row-span-2">
                <label className="block text-sm font-semibold text-slate-700 mb-2">
                  Payment Notes (Optional)
                </label>
                <textarea
                  rows="4"
                  className="w-full border border-slate-300 rounded-lg px-4 py-2.5 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all resize-none"
                  placeholder="Add any additional notes here..."
                  {...register('Payment_notes')}
                />
              </div>

              <div className="relative z-0">
                <label className="block text-sm font-semibold text-slate-700 mb-2">
                  Vendor <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <PaymentVendorSelect
                    list={paymentAtomData.vendor || []}
                    defaultValue={paymentEdit?.payment_info?.[0]?.vendor_name}
                    selected={onVendorSelect}
                  />
                </div>
              </div>

              <div className="relative z-0">
                <label className="block text-sm font-semibold text-slate-700 mb-2">
                  Pay Through Account <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <PaymentMadeMethod
                    list={paymentAtomData.payment_through || []}
                    selected={onPaymentMethodSelect}
                    defaultValue={paymentEdit?.payment_info?.[0]?.payment_through_name}
                    {...register('payment_through_id', { required: 'Pay Through Account is required!' })}
                  />
                </div>
                {errors.warehouse_to_id && (
                  <p className="text-red-500 text-xs mt-1">{errors.p.message}</p>
                )}
              </div>

              {/* Total Payment Amount — NumericFormat */}
              <div>
                <label className="block text-sm font-semibold text-slate-700 mb-2">
                  Total Payment Amount
                </label>
                <NumericFormat
                  thousandSeparator=","
                  decimalSeparator="."
                  decimalScale={2}
                  fixedDecimalScale={false}
                  allowNegative={false}
                  className="w-full border border-slate-300 rounded-lg px-4 py-2.5 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                  placeholder="Enter total amount to distribute"
                  value={totalPaymentAmount}
                  onValueChange={({ floatValue }) => handleTotalPaymentChange(floatValue ?? '')}
                />
                <p className="text-xs text-slate-500 mt-1">
                  Amount will be distributed across bills automatically
                </p>
              </div>

              {/* Excess Amount — NumericFormat (read-only) */}
              <div>
                <label className="block text-sm font-semibold text-slate-700 mb-2">
                  Excess Amount
                </label>
                <NumericFormat
                  thousandSeparator=","
                  decimalSeparator="."
                  decimalScale={2}
                  fixedDecimalScale={false}
                  allowNegative={false}
                  readOnly
                  className="w-full border border-slate-300 rounded-lg px-4 py-2.5 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all bg-slate-50 text-slate-500 cursor-not-allowed"
                  value={excessAmount}
                />
              </div>

              {/* Adjustment Amount — NumericFormat */}
              <div>
                <label className="block text-sm font-semibold text-slate-700 mb-2">
                  Adjustment Amount
                </label>
                <NumericFormat
                  thousandSeparator=","
                  decimalSeparator="."
                  decimalScale={2}
                  fixedDecimalScale={false}
                  allowNegative={false}
                  className="w-full border border-slate-300 rounded-lg px-4 py-2.5 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                  value={adjustmentAmount}
                  onValueChange={({ floatValue }) => handleAdjustmentAmountChange(floatValue ?? 0)}
                />
              </div>

              <div className="relative z-0">
                <label className="flex items-center gap-2 text-sm font-semibold text-slate-700 mb-2">
                  <input
                    type="checkbox"
                    checked={showTaxSelect}
                    onChange={(e) => setShowTaxSelect(e.target.checked)}
                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                  />
                  <span> Deduct TDS Tax</span>
                </label>
                {showTaxSelect && (
                  <div className="relative">
                    <PaymentMadeTaxSelect
                      list={paymentAtomData.tax_info || []}
                      selected={onTaxTypeSelect}
                    />
                  </div>
                )}
              </div>

              {prevExcessAmount > 0 && (
                <div className="relative z-0">
                  <label className="flex items-center gap-2 text-sm font-semibold text-slate-700 mb-2">
                    <span> Excess Amt: {formatCustomNumber(prevExcessAmount)} </span>
                  </label>
                  <button onClick={handleAdjustExcessAmount} className="bg-buttonColor text-white px-4 py-2 rounded-lg">
                    Adjust Excess Amount
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Items Table Card */}
        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
          <div className="bg-gradient-to-r from-slate-700 to-slate-800 px-6 py-4 flex items-center justify-between">
            <h3 className="text-lg font-semibold text-white flex items-center gap-2">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
              </svg>
              Bill(s)
            </h3>
            <span className="bg-white text-slate-800 px-3 py-1 rounded-full text-sm font-semibold">
              {vendorBillList.length} {vendorBillList.length === 1 ? 'item' : 'items'}
            </span>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-slate-50 border-b-2 border-slate-200">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-slate-700 uppercase tracking-wider">Ref</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-slate-700 uppercase tracking-wider">Bill No</th>
                  <th className="px-4 py-3 text-center text-xs font-semibold text-slate-700 uppercase tracking-wider">Date</th>
                  <th className="px-4 py-3 text-center text-xs font-semibold text-slate-700 uppercase tracking-wider">Bill Amount</th>
                  <th className="px-4 py-3 text-center text-xs font-semibold text-slate-700 uppercase tracking-wider">Re. Balance</th>
                  <th className="px-4 py-3 text-center text-xs font-semibold text-slate-700 uppercase tracking-wider">Paying</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-200">
                {vendorBillList.map((bill, index) => (
                  <tr key={bill.item_id} className="hover:bg-slate-50 transition-colors">
                    <td className="px-4 py-4 text-sm text-slate-700 font-medium">{bill.bill_ref_no}</td>
                    <td className="px-4 py-4">
                      <div className="flex flex-col">
                        <span className="text-sm font-medium text-slate-800">{bill.bill_number}</span>
                      </div>
                    </td>
                    <td className="px-4 py-4 text-sm text-slate-600 text-left">{formatCustomDateWithoutTime(bill.bill_date)}</td>
                    <td className="px-4 py-4 text-sm text-slate-600 text-center">{formatCustomNumber(bill.bill_amount)}</td>
                    <td className="px-4 py-4 text-sm text-slate-600 text-center">{formatCustomNumber(bill.remaining_amount)}</td>
                    <td className="px-4 py-4 text-center">
                      {/* Per-bill Paying Amount — NumericFormat */}
                      <NumericFormat
                        thousandSeparator=","
                        decimalSeparator="."
                        decimalScale={2}
                        fixedDecimalScale={false}
                        allowNegative={false}
                        className="w-24 border border-slate-300 rounded-lg px-3 py-1.5 text-sm text-center focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        value={bill.payment_amount}
                        onValueChange={({ floatValue }) =>
                          updatePayingAmount(bill.bill_ref_no, floatValue ?? 0, bill)
                        }
                      />
                    </td>
                    <td className="px-4 py-4 text-center"></td>
                  </tr>
                ))}
                {vendorBillList.length === 0 && (
                  <tr>
                    <td colSpan="6" className="px-4 py-12 text-center">
                      <div className="flex flex-col items-center justify-center text-slate-400">
                        <svg className="w-16 h-16 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
                        </svg>
                        <p className="text-lg font-medium">No products added yet</p>
                        <p className="text-sm mt-1">Select a product and click "Add Item" to begin</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="mt-8 flex flex-col sm:flex-row justify-end gap-3">
          <button
            onClick={handleCancel}
            className="px-8 py-3 border-2 border-slate-300 text-slate-700 rounded-lg text-sm font-semibold hover:bg-slate-50 transition-all"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="px-8 py-3 bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white rounded-lg text-sm font-semibold transition-all shadow-md hover:shadow-lg flex items-center justify-center gap-2"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            {paymentEdit?.payment_info?.[0]?.payment_ref_no ? "Update Payment" : "Save Payment"}
          </button>
        </div>
      </div>
    </div>
  );
}